<template>
  <div>
  <div ref="chart" class="videoDay" v-show="info"></div>
  <div v-show="!info" class="chart">
    <none-data :height="3.5" />
  </div>
  </div>
</template>

<script>
const today = new Date();
const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
const formattedYesterday = `${yesterday.getFullYear()}${String(yesterday.getMonth() + 1).padStart(2, '0')}${String(yesterday.getDate()).padStart(2, '0')}`;
export default {
  props:{
    dayNum:Number,
    onlySales:Boolean
  },
  data() {
    return {
      info:true
    };
  },
  mounted() {
    this.getvideoDay()
  },
  computed:{

  },
  watch:{
    dayNum:{
      handler() {
        this.getvideoDay()
      }
    },
    onlySales: {
      handler() {
        this.getvideoDay()
      }
    }
  },
  methods: {  
   yAxis(arr) {
     if(Math.max(...arr) > 6) {
      return {type:"value"}
     } else {
      return {type:"value",interval:1}
     }
   },   
    getvideoDay() {
           this.$get({
          road: 'opusDateStatistic',
          data: { anchorId: this.$route.params.id },
          params: { timeMode: this.dayNum, time: formattedYesterday,onlySales:this.onlySales },
          version: 'v22'
        }).then(res => {
         const arr = res.data.x.map(item => item.toString().slice(-4))
         this.info = res.data.x.length && res.data.y.length
        this.drawChart({...res.data,x:arr});
        }).finally(() => {
          this.$toast.clear()
        })
    },
    text(str) {
    return  str.toString().slice(0,2) + '-' +  str.toString().slice(2)
    },
    // 字体适配
  FontChart(res) {
          //获取到屏幕的宽度
          var clientWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth; 
          if (!clientWidth) return; //报错拦截：
          let fontSize = 10 * (clientWidth / 1920);
          return res * fontSize;
        },
    drawChart(info) {
      echarts.init(this.$refs.chart).setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: { type: 'shadow' },
          formatter: (data) => {
             return  `<div style="display:flex;align-items: center;"> <div style="width: 5px;height:8px;background-color:#2877FF;margin-right:5px"></div>${this.text(data[0].name)}</div>
                      <div style="display:flex;align-items: center;"> <div style="margin-right:5px;font-size: 12px;color:#696D75;font-family: number-bold;">视频数</div>${data[0].data}</div>`
          },
        },
        title: {
          subtext: '视频数',
          top:-10
        },
        xAxis: {
          type: "category",
          data: info.x,
        },
         yAxis: this.yAxis(info.y),
        // yAxis: {
        //   type: "value",
        //   interval:none
        // },
        series: [
          {
            data: info.y,
            type: "line",
            showSymbol: false,
            lineStyle: {
            color: '#2877FF' // 设置线的颜色为红色
               },
          },
        ],
        grid: {
          left: this.FontChart(11),
          top: this.FontChart(13),
          bottom: this.FontChart(14),
          right: this.FontChart(5 ),
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.videoDay {
  margin-top: 0.24rem;
  width: 7rem;
  height: 3.5rem;
}
.chart_box {
  width: 100px;
  height: 100px;
  background-color: #000;
}
</style>
